import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/hostnic/apple-touch-icon.png?url";
import icon from "@/styles/hostnic/favicon.ico?url";
import favicon from "@/styles/hostnic/favicon.svg?url";
import loginIntroBg from "@/styles/hostnic/login-bg.svg?url";
import logoDark from "@/styles/hostnic/logo-dark.svg?url";
import loginLogo from "@/styles/hostnic/logo.svg";
import logo from "@/styles/hostnic/logo.svg?url";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#1096C5",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "button-border-radius": "24px",
        "button-new-bg": "#2BCD97",

        "header-logo-width": "72px",
        "header-logo-height": "16px",

        "icon-radio-primary-bg": "#2BCD97",
        "icon-radio-border-radius": "10px",

        "sidebar-item-icon-color": "#2BCD97",
        "sidebar-header-button-color": "#2BCD97",

        "sidenav-bg-color": "#122C40",
        "sidenav-item-border": "1px solid transparent",
        "sidenav-item-icon-color": "#2BCD97",
        "sidenav-item-bg-color": "transparent",
        "sidenav-item-text-color": "#FFFFFF",
        "sidenav-item-before-width": "1px",
        "sidenav-item-hover-bg-color": "#2BCD97",
        "sidenav-item-hover-icon-color": "#FFFFFF",
        "sidenav-item-hover-text-color": "#FFFFFF",
        "sidenav-item-active-bg-color": "#2BCD97",
        "sidenav-item-active-icon-color": "#FFFFFF",
        "sidenav-item-active-text-color": "#FFFFFF",
        "sidenav-item-active-before-display": "none",
        "sidenav-item-border-radius": "0",

        //#region Login
        "login-body-bg-color": "var(--color-white)",
        "login-body-bg-size": "cover",
        "login-body-text-color": "var(--color-white)",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-display": "flex",
        "login-intro-bg-image": `url("${loginIntroBg}")`,
        "login-intro-bg-size": "cover",
        "login-intro-bg-position": "0 0",
        "login-intro-text-align": "left",
        "login-intro-flex-direction": "column",
        "login-intro-justify-content": "flex-end",
        "login-intro-align-items": "flex-start",
        "login-intro-padding": "60px",
        "login-title-font-size": "28px",
        "login-title-text-color": "",
        "login-title-font-weight": 600,
        "login-title-line-height": 1,
        "login-title-max-width": "400px",
        "login-title-padding": "0 0 16px 0",
        "login-subtitle-font-size": "16px",
        "login-subtitle-max-width": "400px",

        "login-form-title-font-size": "20px",
        "login-form-input-bg-color": "#FFFFFF",
        "login-form-bg-color": "#122c40",
        "login-form-text-color": "var(--color-white)",
        "login-form-input-border-color": "transparent",
        "login-form-button-border-radius": "24px",
        "login-form-button-border-color": "#2BCD97",
        "login-form-button-bg-color": "#2BCD97",
        "login-form-or-text-color": "#ffffff",
        "login-form-or-border-color": "#ffffff",
        "login-form-google-bg-color": "#ffffff",
        "login-form-google-text-color": "#db4437",
        "login-form-more-text-color": "#ffffff",
        "login-form-more-bg-color": "transparent",
        "login-form-more-border-color": "#ffffff",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "133px",
        },
    },
    loginIntro: {
        style: {
            position: "relative",
            zIndex: 10,
            order: 2,
        },
    },
    loginForm: {
        style: {
            order: 1,
            width: "50%",
            justifyContent: "flex-end",
        },
    },
    loginFormInner: {
        style: {
            maxWidth: "450px",
        },
    },
    loginFormBefore: {
        style: {
            display: "block",
            top: 0,
            right: "-180px",
            backgroundColor: "var(--login-form-bg-color)",
            width: "180px",
            height: "100%",
            aspectRatio: "1/10",
            clipPath: "polygon(100% 0, 0 100%, 0 0)",
        },
    },
};
